import { render, staticRenderFns } from "./childtemplate.vue?vue&type=template&id=9db65ab6&scoped=true"
import script from "./childtemplate.vue?vue&type=script&lang=js"
export * from "./childtemplate.vue?vue&type=script&lang=js"
import style0 from "./childtemplate.vue?vue&type=style&index=0&id=9db65ab6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db65ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9db65ab6')) {
      api.createRecord('9db65ab6', component.options)
    } else {
      api.reload('9db65ab6', component.options)
    }
    module.hot.accept("./childtemplate.vue?vue&type=template&id=9db65ab6&scoped=true", function () {
      api.rerender('9db65ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/task/static/childtemplate.vue"
export default component.exports